import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { urlAssets, urlEspecial, queryStrStart, queryStrParam } from '../../Constants';

//components
import Confederation from './Confederation';
import Team from './Team';


const Teams = props => {

    const { teams } = props;
    
    return (
        <section className="my-3 mx-4 px-2">
            {
                teams.map(team => 
                    <Fragment key={team.id}>
                        <Confederation key={team.id} slug={team.slug} name={team.name} urlAssets={urlAssets} />
                        <section className="row qualified-teams mb-3 px-3">
                            {
                                (team.teams).map(tm => 
                                    <Team 
                                        key={tm.id} 
                                        name={tm.name} 
                                        slug={tm.slug} 
                                        urlAssets={urlAssets} 
                                        urlEspecial={urlEspecial}
                                        queryStrStart={queryStrStart}
                                        queryStrParam={queryStrParam}
                                    />
                                )
                            }
                        </section>
                    </Fragment>
                )
            }
            
            
        </section>
        
    )
}

export default Teams;

Teams.propTypes = {
    teams: PropTypes.array.isRequired
}